/*
 * @Author: LUOHM
 * @Date: 2022-05-11 11:09:41
 * @LastEditTime: 2022-05-23 10:26:18
 * @LastEditors: LUOHM
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'normalize.css' //样式优化
import fastClick from 'fastclick'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import i18n from './in18n'
import store from './store'
import VConsole from 'vconsole'
import AutoFocus from 'vue-auto-focus'


if (process.env.NODE_ENV === 'development') {
  const vConsole = new VConsole()
}

Vue.config.productionTip = false
Vue.use(MintUI)
Vue.prototype.$s = store
fastClick.attach(document.body)

Vue.use(AutoFocus)

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
